import React from 'react';
import Skeleton from "react-loading-skeleton";
function MenuSkeleton() {
    return(
        <Skeleton height={622} style={{ width: "100%" }}/>
    );
}
export default MenuSkeleton;